import {
   HealthcareFacilityPart,
   HealthcareFacilityPartForCurrentOrganizationQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { Message, MessageType, StandardSpinner } from '@dreryk/react-components';

type HealthcareFacilityDropdownLoaderRenderProps = {
   healthcareFacilityParts: HealthcareFacilityPart[];
};

type HealthcareFacilityDropdownLoaderProps = {
   readonly children: (renderProps: HealthcareFacilityDropdownLoaderRenderProps) => JSX.Element;
};

export const HealthcareFacilityDropdownLoader = (props: HealthcareFacilityDropdownLoaderProps): JSX.Element => {
   const {
      data: healthcareFacilityParts,
      loading: healthcareFacilityPartsLoading,
      error: healthcareFacilityPartError,
   } = useCqrsSearch<HealthcareFacilityPart>(() => {
      return new HealthcareFacilityPartForCurrentOrganizationQuery();
   });

   if (healthcareFacilityPartsLoading) {
      return <StandardSpinner />;
   }

   if (healthcareFacilityPartError) {
      return (
         <Message
            testId={'failedToFetchPersonalData'}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      healthcareFacilityParts: healthcareFacilityParts,
   });
};
